import { API_ROUTES } from '@config/routes';
import api from './api';

export interface SchedulerTemplate {
  id: string;
  title: string;
  durationMinutes: number;
  location: string;
  calendarDescription: string;
  bookingWindowDays: number;
  minimumNoticeHours: number;
  slotIncrementMinutes: number;
  welcomeBanner: string;
  isDefault: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export type SchedulerTemplatePayload = Omit<
  SchedulerTemplate,
  'id' | 'isDefault' | 'createdAt' | 'updatedAt'
>;

export interface LeadSchedulerSettings {
  projectId?: string;
  templateId: string;
  requiresApproval: boolean;
  autoSendEnabled: boolean;
  sendDelayHours: number;
  updatedAt?: string | null;
}

export type LeadSchedulerSettingsMap = Record<string, LeadSchedulerSettings>;

export const schedulerService = {
  getTemplates: (): Promise<SchedulerTemplate[]> =>
    api.get<SchedulerTemplate[]>(API_ROUTES.SCHEDULER.TEMPLATES),

  createTemplate: (template: SchedulerTemplatePayload): Promise<SchedulerTemplate> =>
    api.post<SchedulerTemplate>(API_ROUTES.SCHEDULER.TEMPLATES, template),

  updateTemplate: (
    templateId: string,
    updates: Partial<SchedulerTemplatePayload>
  ): Promise<SchedulerTemplate> =>
    api.put<SchedulerTemplate>(API_ROUTES.SCHEDULER.TEMPLATE_BY_ID(templateId), updates),

  deleteTemplate: (templateId: string): Promise<{ deleted: boolean }> =>
    api.delete<{ deleted: boolean }>(API_ROUTES.SCHEDULER.TEMPLATE_BY_ID(templateId)),

  getSettings: (): Promise<LeadSchedulerSettingsMap> =>
    api.get<LeadSchedulerSettingsMap>(API_ROUTES.SCHEDULER.SETTINGS),

  saveProjectSettings: (
    projectId: string,
    settings: LeadSchedulerSettings
  ): Promise<LeadSchedulerSettings> =>
    api.put<LeadSchedulerSettings>(API_ROUTES.SCHEDULER.SETTINGS_BY_PROJECT(projectId), settings),
};
